import React from "react";
import styles from "../../../Handbook.module.css";

interface HandbookShellProps {
    title: string;
    children: React.ReactNode;
}

export const HandbookShell = ({
                                  title,
                                  children,
                              }: HandbookShellProps) => {
    return (
        <>
            <div className={styles.shellHeader}>
                <h1 className={styles.shellTitle}>{title}</h1>
            </div>

            {children}
        </>
    );
};
